import { Text } from "@react-three/drei"
import { useIsMobile } from "../../../utils/useIsMobile"

export default function TextActTwo(props) {
    const isMobile = useIsMobile()
    return(
        <>
            <Text {...props} font={"./font/Mattone-Regular.woff"} fontSize={isMobile ? 1 : 0.7}>
                Come visit my universe
            </Text>
        </>
    )
}